import React from 'react';
import { Stack, ToggleButtonGroup, ToggleButton, FormControlLabel, Switch } from '@mui/material';

const WINDOWS = [
  { key: '7d', label: '7d' },
  { key: '30d', label: '30d' },
  { key: '90d', label: '90d' },
  { key: 'ytd', label: 'YTD' },
  { key: 'all', label: 'All' },
];

export default function ReportFilterBar({ value, onChange, includeArchivedToggle = false, extra }) {
  const handleWindow = (_, next) => {
    if (!next) return;
    onChange({ ...value, window: next });
  };
  return (
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
      <ToggleButtonGroup size="small" value={value.window || '30d'} exclusive onChange={handleWindow}>
        {WINDOWS.map((w) => (
          <ToggleButton key={w.key} value={w.key}>{w.label}</ToggleButton>
        ))}
      </ToggleButtonGroup>
      {includeArchivedToggle && (
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={!!value.includeArchived}
              onChange={(e) => onChange({ ...value, includeArchived: e.target.checked })}
            />
          }
          label="Include archived"
        />
      )}
      {extra}
    </Stack>
  );
}
